@import '../../../../node_modules/swiper/swiper.min.css';
@import '../../../../node_modules/swiper/modules/navigation.min.css';
@import '../../../../node_modules/swiper/modules/grid.min.css';

:host {
  display: block;
}

.swiper-brand {
  font-family: var(--primary-font);
  position: relative;
  height: auto;
  margin: 0 auto;
  padding-top: 50px;
  padding-bottom: 50px;

  .swiper-navigation {
    position: absolute;
    bottom: -10px;
    left: 50%;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 150px;
    transform: translate(-50%, 0);

    @include breakpointMin('md') {
      position: absolute;
      top: 5px;
      right: 0px;
      height: 50px;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 150px;
      transform: inherit;
      left: initial;
      bottom: initial;
    }

    .swiper-pagination {
      display: flex;
      justify-content: center;
      align-items: center;
      bottom: 15px;
    }

    .swiper-button-next {
      &:after {
        width: 30px;
        height: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 12px;
        background: var(--color-bleached-silk);
        border-radius: 50px;
        color: var(--color-nero);
      }
    }

    .swiper-button-prev {
      &:after {
        width: 30px;
        height: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 12px;
        background: var(--color-bleached-silk);
        border-radius: 50px;
        color: var(--color-nero);
      }
    }
  }

  &-link {
    position: absolute;
    left: 10px;
    top: 20px;
    width: 100%;
    text-align: center;

    @include breakpointMin('md') {
      width: auto;
      text-align: left;
    }
  }

  lilu-hr {
    padding-left: 5px;
    padding-right: 5px;
    margin: 0 auto;
    max-width: 1600px;

    @include breakpointMin('md') {
      padding-left: 10px;
      padding-right: 10px;
    }
  }
}
